export type IgrowFormValues = {
  parentName: string;
  parentPhone: string;
  parentEmail: string;
  childName: string;
  childAge: string;
  childSchool: string;
  communicationPreference: string;
  loves: string;
  activities: string;
  goals: string;
  consentContact: boolean;
  consentAccuracy: boolean;
  areas: string[];
};

export type IgrowFieldName =
  | 'parentName'
  | 'parentPhone'
  | 'parentEmail'
  | 'childName'
  | 'childAge'
  | 'loves'
  | 'consentContact'
  | 'consentAccuracy';

export const FIELD_ORDER: IgrowFieldName[] = [
  'parentName',
  'parentPhone',
  'parentEmail',
  'childName',
  'childAge',
  'loves',
  'consentContact',
  'consentAccuracy',
];

export type IgrowFieldErrors = Partial<Record<IgrowFieldName, string>>;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^[\d\s+\-()]+$/;

export function validateIgrowForm(values: IgrowFormValues): IgrowFieldErrors {
  const errors: IgrowFieldErrors = {};

  if (!values.parentName.trim()) {
    errors.parentName = 'Full name is required.';
  }

  const phone = values.parentPhone.trim();
  if (!phone) {
    errors.parentPhone = 'Contact number is required.';
  } else if (!PHONE_PATTERN.test(phone)) {
    errors.parentPhone = 'Use digits, spaces, +, -, or brackets only.';
  } else {
    const digits = phone.replace(/\D/g, '').length;
    if (digits < 7 || digits > 15) {
      errors.parentPhone = 'Enter a valid contact number.';
    }
  }

  const email = values.parentEmail.trim();
  if (!email) {
    errors.parentEmail = 'Email address is required.';
  } else if (!EMAIL_PATTERN.test(email)) {
    errors.parentEmail = 'Enter a valid email address.';
  }

  if (!values.childName.trim()) {
    errors.childName = "Child's full name is required.";
  }

  const age = values.childAge.trim();
  if (!age) {
    errors.childAge = "Child's age is required.";
  } else if (!/^\d+$/.test(age) || Number(age) < 1 || Number(age) > 25) {
    errors.childAge = 'Enter an age between 1 and 25.';
  }

  if (!values.loves.trim()) {
    errors.loves = 'Please tell us what your child loves.';
  }

  if (!values.consentContact) {
    errors.consentContact = 'Permission to be contacted is required.';
  }

  if (!values.consentAccuracy) {
    errors.consentAccuracy = 'Please confirm the information is accurate.';
  }

  return errors;
}
